<template>
	<div class="focusenterprises">
		<leftnav class="fl" mkcode="E" itemcode="E-xlrxm" :mkopen="true" title="企业-城市关系计算器"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<findProjectsTab :currentTab="'3'"></findProjectsTab>

				<div class="whitebox right_topbox" style="min-height: 300px;" v-if="userdata.token">
					<!-- <div class="right_boxtitle">
							<span :class="{'fl right_title':true,'current':calcuCityType=='市'}" @click="toggleType('市')">本市关系计算器</span>
							<span :class="{'fl right_title red-icon':true,'current':calcuCityType=='省'}" data="VIP" @click="toggleType('省')">本省关系计算器</span>
							<el-tooltip class="item smartTip-text" effect="light" placement="top-start">
								<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
								<div slot="content" class="list_tips">
									<p>企业-城市 关系计算器： {{curWebsite.shortlistName}}企业在所属城市的关联企业</p>
									<p v-if="userdata.currentCity.type == 'county'">标注为“<em class="redfont">*</em>”的企业为所属区县的关联企业。</p>
								</div>
							</el-tooltip>
						</div> -->
					<div class="map_title_tab">
						<span :class="{ 'title': true, 'current': calcuCityType == '市' }"
							@click="toggleType('市')">本市关系计算器</span>
						<span :class="{ 'title red-icon': true, 'current': calcuCityType == '省' }" data=""
							@click="toggleType('省')">本省关系计算器</span>
						<vedioTips :type="7" class="fr"></vedioTips>
						<!--clueType == 3目前后台进度只做到外地企业加城市筛选 一级关系和二级关系还没有加-->
					</div>
					<ul class="user_tabtitle1 flexcss" style="margin-top:16px;">
						<li :class="clueType == 3 ? 'current red-icon' : 'red-icon'"
							@click="clueType = 3; showRelationScreen()" data="">本{{ calcuCityType }}企业关联的外地企业</li>
						<li :class="clueType == 1 ? 'current' : ''" @click="clueType = 1; getEnterpriseRelated(1)">一级关系圈
						</li>
						<li :class="clueType == 2 ? 'current' : ''" @click="clueType = 2; getcacheRelatedlist()">二级关系圈
						</li>
					</ul>
					<div class="right_boxtitle" v-show="clueType == 3">
						<div class="fl search-box mb-3">
							<span class="searchtype">本地企业关联的外地企业</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div class="opport-screen-list1" v-show="calcuCityType == '省'">
						<!--clueType == 3目前后台进度只做到外地企业加城市筛选 一级关系和二级关系还没有加-->
						<dl class="opport-screen bdbe">
							<dt class="fl">本省城市</dt>
							<dd class="fl">
								<span v-for="(item, index) in provinceData" :key="index"
									:class="calcuCityid == item.areaId ? 'a-screen current' : 'a-screen'"
									@click="provinceCityCalcu(item)">{{ item.areaName }} </span>
							</dd>
						</dl>
					</div>
					<div class="enterprise_list_box" v-show="clueType == 1">
						<div class="secondaryEmptyText" v-show="RelatedList.length == 0">未找到对应关系</div>

						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table"
							v-show="RelatedList.length > 0">
							<tr>
								<th>{{ curWebsite.shortlistName }}</th>
								<th>所属关系</th>
								<th>{{ calCuData.text }}关联企业</th>
								<th>详细地址</th>
								<th>联系电话</th>
							</tr>
							<tr v-for="(list, index) in RelatedList" :key="index" v-if="index < firstCompanyNum">
								<!-- <td class="title" @click="routerlinkid('/enterprises',list.stockCode)">{{list.title}} </td> -->
								<td v-if="list.grade == 1" :rowspan="list.rowspan" class="rowspantitle title"
									@click="routerlinkid('/enterprises', list.stockCode)">{{ list.title }}</td>
								<td>
									<span v-if="list.relationship == '控制企业'" class="relationship-arrow">
										<em>控制企业——被控制企业</em>
									</span>
									<span v-if="list.relationship == '供应商'" class="relationship-arrow">
										<em>供应商——客户</em>
									</span>
									<span v-if="list.relationship == '客户'" class="relationship-arrow">
										<em>客户——供应商</em>
									</span>
									<span v-if="list.relationship == '对外投资'" class="relationship-arrow">
										<em>对外投资——获投企业</em>
									</span>
									<span v-if="list.relationship == '股东'" class="relationship-arrow">
										<em>股东——入股企业</em>
									</span>
									<span v-if="list.relationship == '投资机构'" class="relationship-arrow">
										<em class="border-bottom-after db">相同投资机构</em><em class="curp db"
											:class="i + 1 > middleItem.length ? ' border-bottom-after' : ''"
											v-for="(middleItem, i) in list.middleList" :key="i"
											@click="routerlinkid('/investement-enterprises', middleItem.id)">{{
												middleItem.name }}</em>
									</span>
									<span v-if="list.relationship == '商会'" class="relationship-arrow">
										<em class="border-bottom-after db">相同商会</em><em class="curp db"
											:class="i + 1 > middleItem.length ? ' border-bottom-after' : ''"
											v-for="(middleItem, i) in list.middleList" :key="i"
											@click="routerlinkid('/commerceDetail', middleItem.id)">{{ middleItem.name
											}}</em>
									</span>
									<span v-if="list.relationship == '协会'" class="relationship-arrow">
										<em class="border-bottom-after db">相同协会</em><em class="curp db"
											:class="i + 1 > middleItem.length ? ' border-bottom-after' : ''"
											v-for="(middleItem, i) in list.middleList" :key="i"
											@click="routerlinkid('/associationDetail', middleItem.id)">{{
												middleItem.name
											}}</em>
									</span>
									<span v-if="list.relationship == '高管'" class="relationship-arrow">
										<em class="border-bottom-after db">相同高管</em><em class="curp db"
											:class="i + 1 > middleItem.length ? ' border-bottom-after' : ''"
											v-for="(middleItem, i) in list.middleList" :key="i"
											@click="routerlinkid('/associationDetail', middleItem.id)">{{
												middleItem.name
											}}</em>
									</span>
								</td>
								<td> <span class="curp" :class="userdata.areaKey == list.areaKey ? 'current' : ''"
										@click="routerlinkid('/enterprises', list.smstockCode)"><em
											class="redfont starTag" v-if="list.isCounty > 0">*</em>{{ list.smtitle
										}}</span>
								</td>
								<td>{{ list.address }}</td>
								<td>{{ list.phone }}</td>
							</tr>
						</table>
						<freeUserTips :type="1" :bgtype="17" v-if="RelatedList.length > 2 && userdata.isFree">
						</freeUserTips>
					</div>
					<div class="enterprise_list_box" v-show="clueType == 2">
						<ul class="secondarylist oh">
							<li v-for="(item, i) in secondaryNameList" class="oh" :key="i">
								<span class="curp fl" @click="routerlinkid('/enterprises', item.stockCode)">{{
									item.title }} </span>
								<span class="caculatBtn fr" v-if="item.iscache">计算完成</span>
								<span class="caculatBtn basebtn fr" v-if="!item.iscache"
									@click="getLevel2List('calcu', item.title, item.stockCode)">开始计算</span>
							</li>
						</ul>
						<div class="secondaryEmptyText" v-show="secondaryEmptyText != ''">
							{{ secondaryEmptyText }}
						</div>
						<div class="target-clueTable" v-show="secondaryList.length > 0">
							<div v-for="(list, i) in secondaryList" :key="i" v-if="i < secondCompanyNum">
								<div class="clue-table-tbody" v-if="list.children.length == 0">
									<div class="clue-table-tr">
										<h5 class="clue-table-td1 clue-table-th"
											@click="routerlinkid('/enterprises', list.stockCode)">{{ list.title }}</h5>
										<div class="clue-table-td8 clue-table-th">未找到对应关系</div>
									</div>
								</div>
								<div class="clue-table-tbody" v-for="(list2, o) in list.children" :key="o"
									v-if="o < getlength(list.children, 1)">
									<div class="clue-table-tr">
										<h5 class="clue-table-td1 clue-table-th">
											<span class="title fwb"
												@click="routerlinkid('/enterprises', list.stockCode)"
												:title="list.title + '的' + list2.relationship">{{ list.title
												}}</span>的{{ list2.relationship }}
										</h5>
										<h5 class="clue-table-td3 clue-table-th">所属关系</h5>
										<h5 class="clue-table-td2 clue-table-th">{{ calCuData.text }}关联企业</h5>
										<h5 class="clue-table-td4 clue-table-th">详细地址</h5>
										<h5 class="clue-table-td5 clue-table-th">联系电话</h5>
									</div>
									<dl v-for="(smlist, d) in list2.list" class="clue-table-tr" :key="d">
										<dt class="clue-table-dt"
											:style="'px;line-height:' + smlist.children.length * 54 + 'px'">
											<!--'height:'+smlist.children.length*46+ ps:感觉不需要高度，行高自己会挤开高度，高度比行高短的时候边框就短了-->
											<span @click="routerlinkid('/enterprises', smlist.stockCode)"
												class="curp">{{ smlist.title }} </span>
										</dt>
										<dd style="width: 80%;">
											<div v-for="(thirdlist, i) in smlist.children" class="oh" :key="i">
												<div class="fl clue-table-td oh">
													<span v-if="thirdlist.relationship == '控制企业'"
														class="relationship-arrow"><em>控制企业——被控制企业</em></span>
													<span v-if="thirdlist.relationship == '供应商'"
														class="relationship-arrow"><em>供应商——客户</em></span>
													<span v-if="thirdlist.relationship == '客户'"
														class="relationship-arrow"><em>客户——供应商</em></span>
													<span v-if="thirdlist.relationship == '对外投资'"
														class="relationship-arrow"><em>对外投资——获投企业</em></span>
													<span v-if="thirdlist.relationship == '股东'"
														class="relationship-arrow"><em>股东——入股企业</em></span>
													<span v-if="thirdlist.relationship == '投资机构'"
														class="relationship-arrow"><em>相同投资机构</em></span>
													<span v-if="thirdlist.relationship == '商会'"
														class="relationship-arrow"><em>相同商会</em></span>
													<span v-if="thirdlist.relationship == '协会'"
														class="relationship-arrow"><em>相同协会</em></span>
													<span v-if="thirdlist.relationship == '高管'"
														class="relationship-arrow"><em>相同高管</em></span>
												</div>
												<span class="fl clue-table-td curp"
													:class="userdata.areaKey == thirdlist.areaKey ? 'current' : ''"
													@click="routerlinkid('/enterprises', thirdlist.stockCode)"><em
														class="redfont starTag" v-if="thirdlist.isCounty > 0">*</em>
													{{ thirdlist.title }}</span>
												<span class="fl clue-table-td">{{ thirdlist.address }}</span>
												<span class="fl clue-table-td">{{ thirdlist.phone }}</span>
											</div>
										</dd>
									</dl>
								</div>
								<freeUserTips :type="1" :bgtype="18" v-if="list.children.length > 2 && userdata.isFree">
								</freeUserTips>
							</div>
						</div>
					</div>
					<div class="enterprise_list_box" v-show="clueType == 3">
						<div class="opport-screen-list1">
							<!-- <div class="spage-searchbox "> -->
							<dl class="opport-screen bdbe">
								<dt class="fl long-font">外地关联城市</dt>
								<dd class="fl">
									<span :class="cityid == 0 ? 'a-screen current' : 'a-screen'"
										@click="hanldCity(0, '全国')">全国地区</span>
									<span v-for="(item, index) in cityData" :key="index"
										:class="cityid == item.areaId ? 'a-screen current' : 'a-screen'"
										@click="hanldCity(item.areaId, item.areaName, item.num)">{{ item.areaName }}<em
											class="num">({{ item.num }})</em></span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe" v-if="cityProvinceList.length > 0">
								<dt class="fl long-font">{{ shortProvinceText }}关联城市</dt>
								<dd class="fl">
									<!-- <span :class="cityid == 0?'a-screen current':'a-screen'" @click="cityid=0;cityText='全国';getThirdRelationList()">全国地区</span>   -->
									<span v-for="(item, index) in cityProvinceList" :key="index"
										:class="cityid == item.areaId ? 'a-screen current' : 'a-screen'"
										@click="cityid = item.areaId; cityText = item.areaName; getThirdRelationList()">{{ item.areaName }}<em
											class="num">({{ item.num }})</em></span>
								</dd>
							</dl>
							<dl class="opport-screen bdbe">
								<dt class="fl long-font">{{ calcuCityType == '市' ? '与本市关系' : '对应城市关系' }} </dt>
								<dd class="fl">
									<span v-for="(item, index) in local_relationship" :key="index"
										:class="data_type == item.value ? 'a-screen current' : 'a-screen'"
										@click="isShowThComp(item.value, item.num)">{{ trunCityType(item.label) }}<em
											class="num">({{ item.num }})</em></span>
								</dd>
							</dl>
							
							<!-- 概念筛选 -->
							<notionScreen :type="1" :notionNumList='[]' :token="userdata.token"
								@chooseNotion="chooseNotion" :isShowNotionScreen="true"></notionScreen>
						</div>
						<div class="enterparise_guide oh" style="width: 100%; ">
							<div class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>
								<em v-if="kwtextsearchtext != ''">【 <span class="orangefont">{{ kwtextsearchtext
										}}</span>】</em> 条相关结果
							</div>
							<!-- <div class="fl" v-else>产业大脑为您找到<span class="searchnum">{{ allTotal }}</span></div> -->
							<!-- <div class="fr oh">
									<el-tooltip class="item smartTip-text" effect="light" placement="right-start">
										<i class="el-icon-question" style="color:cornflowerblue;margin-left: 5px;"></i>
										<div slot="content" class="list_tips">
											<p>批量加入熟悉的企业： 将当前展示列表内的企业添加进熟悉企业列表</p> 
										</div>
									</el-tooltip>
									<div class="fl enlistexportbtn" style="margin-left: 180px;">
										<span style="width: 180px;" @click="batchAddEnterpriseRelation()">批量加入熟悉的企业</span> 
									</div> 
								</div>  -->
						</div>
						<div class="enterprise_list_box">
							<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table nopadding"
								element-loading-text="数据加载中" v-loading="thirdCompanyListLoading">
								<tr>
									<th style="width:10px;padding:0;">排名</th>
									<th>{{ cityText }}关联企业</th>
									<th style="width:10px;padding:0;">城市</th>
									<th v-show="clueType == 3 && data_type == 0">关联关系</th>
									<th>{{ calCuData.text }}关联企业</th>
									<th v-show="isShowTh">{{ trunThType(data_type) }}</th>
									<th>操作</th>
								</tr>
								<tr v-for="(list, i) in thirdCompanyList" :key="i" v-if="i < thirdCompanyNum">
									<td style="width:10px;padding:0;" class="border-right">{{ (page - 1) * pageSize + i
										+ 1 }}
									</td>
									<td class="title border-right" @click="routerlinkid('/enterprises', list.stockCode)"
										v-if="list.rowspan > 0" :rowspan="list.rowspan">{{ list.title }}</td>
									<td style="width:10px;padding:0;" class="border-right">{{ list.areaName }}</td>
									<td v-show="clueType == 3 && data_type == 0">
										<p v-for="(item, chii) in list.localEnterprise" :key="chii"
											v-show="chii < 10 || list.showmore">
											<span v-if="item.dataTypeText == '控制企业'"
												class="relationship-arrow display-block border-right curp-a"><em>控制企业——被控制企业</em></span>
											<span v-if="item.dataTypeText == '供应商'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>供应商——客户</em></span>
											<span v-if="item.dataTypeText == '客户'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>客户——供应商</em></span>
											<span v-if="item.dataTypeText == '对外投资'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>对外投资——获投企业</em></span>
											<span v-if="item.dataTypeText == '股东'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>股东——入股企业</em></span>
											<span v-if="item.dataTypeText == '投资机构'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>相同投资机构</em></span>
											<span v-if="item.dataTypeText == '商会'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>相同商会</em></span>
											<span v-if="item.dataTypeText == '协会'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>相同协会</em></span>
											<span v-if="item.dataTypeText == '高管'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>相同高管</em></span>
											<span v-if="item.dataTypeText == '子公司'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>母公司——子公司</em></span>
											<span v-if="item.dataTypeText == '融资'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>融资——投资</em></span>
											<span v-if="item.dataTypeText == '投资'"
												class="relationship-arrow display-block border-right curp-a"
												:class="{ 'border-bottom': chii < list.localEnterprise.length - 1 }"><em>投资——融资</em></span>

										</p>


									</td>
									<td class="border-right">
										<p v-for="(item, chii) in list.localEnterprise" :key="chii"
											:class="{ 'curp-a': true, 'current': userdata.areaKey == item.areaKey, 'border-bottom': chii < list.localEnterprise.length - 1 }"
											class=" " @click="routerlinkid('/enterprises', item.stockCode)"
											v-show="chii < 10 || list.showmore">{{ item.title }}</p>
										<!-- <p v-if="list.localEnterprise.length>10" class="curp" @click="list.showmore=!list.showmore">{{list.showmore?'隐藏':'查看更多'}}</p> -->
									</td>

									<td v-show="isShowTh" class="border-right"><span class="curs-pointer curp-a"
											:class="userdata.areaKey == list.areaKey ? 'current' : ''"
											@click="routerlinkid(middleRouter, list.middleId)"
											v-show="list.middleName != ''">{{ list.middleName }}</span><span
											v-show="list.middleName == ''">-</span></td>
									<td class="collectfont1">
										<!-- <span class="bde" v-show="list.enterpriseRelationType!=2" :data="list.enterpriseRelationId" @click="toggleRelationEnterprise(list,1)">{{list.enterpriseRelationId > 0?'移除':'加入'}}我熟悉的企业</span> -->
										<span class="bde" @click="listToggleCollect(list)">{{ list.collectId ==
											0 ? '加入' : '移除' }}目标企业</span>
										<span :data="list.crmId" @click="crmtoggle(list, list.stockCode)">{{ list.crmId
											== 0 ? '加入' : '移除' }}项目管理</span>
									</td>
								</tr>
							</table>

							<freeUserTips :type="1" :bgtype="16" v-if="thirdCompanyList.length > 2 && userdata.isFree">
							</freeUserTips>
						</div>
						<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
							<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
								v-bind:max-page="maxPage" v-on:pagehandler="getThirdRelationList"></zpagenav>
						</div>
					</div>
					<!-- 选址项目的试用账户提示 -->
					<!-- <div class="whitebox trial-box" v-if="userdata.groupType == 0 && calcuCityType == '省'">
							<h3>成为正式用户即可解锁更多信息</h3>
							<h4>联系电话：400 008 0552、0755-8257 1568</h4>
						</div> -->
				</div>
				<div v-else>
					<div class="heightVh95 whitebox container-flex-center">
						<freeUserTips :type="4" :bgtype="0" isShowPageTitle="企业-城市关系计算器"></freeUserTips>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import freeUserTips from "@/components/enterpriseInc/free-user-tips.vue"
import {
	dataInJs
} from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'mapserch',
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),
		shortProvinceText() {
			return '广东';
			// return this.userdata.provinceText.replace(/省|市|自治区|特别行政区/g, '');
		}
	},
	data() {
		return {
			title: "企业-城市关系计算器",
			userdata: { currentCity: { type: "city" } },
			curWebsite: this.$api.getWebsiteType(),
			calCuData: {},
			cityText: '全国',
			clueType: 3,
			secondaryList: [],
			secondaryNameList: [],
			secondaryEmptyText: "",
			thirdCompanyList: [],
			iscache: true,
			page: 1, //显示的是哪一页 
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数     
			RelatedList: [], //企业触达线索表格
			oneNameList: "", //一级线索里已有的企业名字  
			local_relationship: [
				{ label: "全部", value: 0, num: 0 },
				{ label: "该市企业的股东", value: 1, num: 0 },
				{ label: "该市企业的对外投资", value: 2, num: 0 },
				{ label: "本市企业的控制企业", value: 9, num: 0 },
				{ label: "该市企业的供应商", value: 3, num: 0 },
				{ label: "该市企业的客户", value: 4, num: 0 },
				{ label: "在该市有拿地的企业", value: 5, num: 0 },
				{ label: "相同投资机构的企业", value: 6, num: 0 },
				{ label: "相同商会的企业", value: 7, num: 0 },
				{ label: "相同协会的企业", value: 8, num: 0 },
				{ label: "相同高管的企业", value: 10, num: 0 },
			],//关系类型 1=股东, 2=子公司, 3=供应商, 4=客户, 5=拿地,6=投资机构, 7=商会, 8=协会，9=控制企业
			data_type: 0,
			cityTotalNum: 20,
			cityData: [],
			cityid: 0,
			notiontext: '',
			notionCode: 0,
			chooseNotionlist: [0, 0, 0, 0, 0],
			//20231122新增本省关系计算器相关内容
			countryData: dataInJs(),
			provinceData: [],
			calcuCityid: 0,
			calcuCityType: '市',
			searchtext: "",
			kwtextsearchtext: "",
			isShowTh: false,
			middleRouter: '',
			relationData: [],
			thirdCompanyNum: 0,
			firstCompanyNum: 0,
			secondCompanyNum: 0,
			thirdCompanyListLoading: false,//表格单独的加载动画
			allTotal: 0, //data_type=0时的总数,因为后台没统计需要按照筛选项上的数字来展示
			cityProvinceList: [],
		}
	},
	components: {
		freeUserTips
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.userdata = this.getuseriformation();
	},
	mounted() {
		if (this.userdata.token) {
			document.getElementById('app').style.background = "#f0f3f5";
			console.log(this.userdata, this.countryData);
			this.provinceData = this.countryData.filter(list => {
				return list.areaId == this.userdata.province;
			});
			this.calcuCityid = this.userdata.city;
			this.provinceData = this.provinceData[0].children;
			this.calCuData = this.getCalcuCity(this.userdata);
			// this.getEnterpriseRelated(1)
			this.showRelationScreen();
		}
	},
	methods: {
		//与外地关联城市点击
		hanldCity(id, name, num) {
			this.cityid = id;
			this.cityText = name;
			this.getThirdRelationList();
			if (id == 0) {
				this.getAllTotal(this.local_relationship[0].num);
			} else {
				this.getAllTotal(num);
			}
		},
		//后台不统计的数据结合
		getAllTotal(total) {
			this.total = total;
		},
		//返回长队
		getlength(data, num) {
			return this.userdata.isFree ? num : data.length;
		},
		//概念单选 层级显示
		chooseNotion(chooseNotionlist, notionCode) {
			this.notionCode = notionCode;
			this.getThirdRelationList(1);
		},
		isShowThComp(type, num) {
			this.data_type = type;
			this.isShowTh = this.data_type == 6 || this.data_type == 7 || this.data_type == 8 || this.data_type == 10;
			if (this.data_type == 6) {
				this.middleRouter = '/investement-enterprises';
			} else if (this.data_type == 7) {
				this.middleRouter = '/commerceDetail';
			} else if (this.data_type == 8) {
				this.middleRouter = '/associationDetail';
			} else if (this.data_type == 10) {
				this.middleRouter = '';
			}
			this.getThirdRelationList();
			this.getAllTotal(num);
			// console.log('是否显示相同机构等',this.isShowTh,this.middleRouter);
			// return this.isShowTh;
		},
		//关系表的数字存值
		setRelationNum(data) {
			this.local_relationship.forEach(list => {
				var types = list.value;
				data.forEach(item => {
					var types1 = item.dataType;
					if (types == types1) {
						list.num = item.num;
					}
				})
			})
		},
		//搜索关键词 
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			this.getThirdRelationList(1,0);
			this.getThirdRelationList();
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		//转换表格相同协会、机构、商会表头名
		trunThType(type) {
			if (type == 6) {
				return '相同机构';
			} else if (type == 7) {
				return '相同商会';
			} else if (type == 8) {
				return '相同协会';
			} else if (type == 10) {
				return '相同高管';
			} else {
				return '不在列表';
			}
		},
		trunCityType(text) {
			if (this.calcuCityType == '省') {
				return text.replace('本市', '该市');
			} else {
				return text.replace('该市', '本市');
			}
		},
		//本省关系计算器和本市关系计算器相互切换
		toggleType(type) {
			this.calcuCityType = type;
			this.clueType = 3;
			if (this.calcuCityType == '省') {
				if (this.userdata.groupType == 0) {
					return;
				} else {
					//跑执行本省关系计算器代码
				}
			} else if (this.calcuCityType == '市') {
				this.calcuCityid = this.userdata.city;
			};
			this.getThirdRelationList(1);
		},
		//关联的外地企业
		showRelationScreen() {
			if (this.thirdCompanyList.length < 1) {
				this.getThirdRelationList(1, 0, false);
				this.getThirdRelationList(1);
			}
		},
		//本省关系计算器城市
		provinceCityCalcu(item) {
			console.log('-----', item, this.calCuData);
			this.calcuCityid = item.areaId;
			this.calCuData = item;
			this.calCuData.text = item.areaName;
			// this.clueType = 3;
			if (this.clueType == 3) {
				this.getThirdRelationList(1);
			}
			else if (this.clueType == 2) {
				this.getcacheRelatedlist();
			} else if (this.clueType == 1) {
				this.getEnterpriseRelated(1);
			}

		},
		//本市关系计算器使用
		getThirdRelationList(page, sub_type, isLoading) {
			console.log('本市关系计算器使用', page);
			if (this.userdata.isFree && page > 1) {
				this.$message({ type: 'warning', message: "本账号试用期已截止,如需延期请即刻与我们联系" });
				return;
			};
			let subType = 0;
			if (this.data_type == 0 && this.clueType == 3 && sub_type != 0) {
				subType = 1; //全部
				this.thirdCompanyList = [];
				this.thirdCompanyListLoading = true;
			} else {
				subType = '';
			}
			var _this = this;
			this.page = page ? page : 1;
			var datatype = this.splicing('dataType', this.data_type);
			var cityn = this.splicing('city', this.cityid);
			var usercityn = this.splicing('userCity', this.calcuCityid);/* 本地只有vip001才有数据 */
			var kwaja = this.splicing('kw', this.searchtext);
			var notionja = this.splicing('notionCode', this.notionCode);
			let subTypeData = this.splicing('subType', subType);
			let url = this.$api.cyl.enterpriseCityRelation.list() + '?page=' + this.page+'&cityNum=30&xmProvince=43' + datatype + cityn + usercityn + kwaja + notionja + subTypeData;
			this.$axios.get(url, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('关联的外地企业', _this.userdata.token, url, res.data)
				if (res.data.success) {
					if (subTypeData == '') {
						_this.cityData = res.data.cityList;
						_this.relationData = res.data.data;
						_this.setRelationNum(res.data.data);
						_this.cityProvinceList = res.data.extend.cityList || []; //本省关系计算器的省份名称
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
					}
					let totalnum = 0;
					for (var i = 0; i < res.data.cityList.length; i++) {
						totalnum += res.data.cityList[i].num;
					};
					res.data.list.forEach(list => {
						list.showmore = false;
						list.rowspan = 1;
					});
					_this.thirdCompanyList = res.data.list;
					_this.thirdCompanyNum = _this.userdata.isFree ? 3 : _this.thirdCompanyList.length;
										// if(_this.data_type > 5){
					// 	_this.thirdCompanyList=_this.mergeSameCompanyName(res.data.list);//机构协会商会需要合并单元格
					// }else{
					// 	_this.thirdCompanyList=res.data.list;
					// }
					_this.cityTotalNum = totalnum;
					_this.kwtextsearchtext = _this.searchtext;
					//结果大于等于0结束加载动画
					if (_this.thirdCompanyList.length >= 0 ) {
						_this.thirdCompanyListLoading = false;
					}
				}
			}).catch(function (error) { });
		},
		//相同投资机构和相同协会商会部分的关联企业会重合 需要合并展示
		mergeSameCompanyName(datalist) {
			var copyData = datalist;
			var lastData = [];
			for (var i = 0; i < datalist.length; i++) {
				let name1 = datalist[i].title;
				if (datalist[i].rowspan > 0) {
					lastData.push(datalist[i]);
					for (var d = 1; d < copyData.length; d++) {
						let name2 = copyData[d].title;
						if (name1 == name2 && i != d) {
							datalist[i].rowspan++;
							datalist[d].rowspan = 0;
							lastData.push(datalist[d]);
						}
					}
				}

			}
			console.log('lastData', lastData)
			return lastData;
		},
		//加入移除项目管理
		crmtoggle(data, enterpiseid) {
			var _this = this;
			if (data.crmId == 0) {
				this.$axios.get(this.$api.crm.enterprise.addtoCRM() + "?stockCode=" + enterpiseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
					console.log("添加到CRM库", res);
					if (res.data.success) {
						data.crmId = res.data.data.id;
						_this.$message({
							type: 'success',
							message: '已加入项目管理',
						});
					}
				}).catch(function (error) { });
			} else {
				console.log('移除', data.crmId)
				$.ajax({
					type: "POST",
					url: this.$api.crm.customer.delete(),
					data: { id: data.crmId },
					headers: { AuthToken: this.userdata.token },
					success: function (res) {
						if (res.success) {
							data.crmId = 0;
							_this.$message({
								type: 'success',
								message: '已移除项目管理',
							});
						} else {
							_this.$message({ type: "error", message: res.msg })
						}
					}
				})
			}
		},
		//批量添加我熟悉的企业
		batchAddEnterpriseRelation() {
			var data1 = [], _this = this;
			this.thirdCompanyList.forEach(list => {
				if (list.enterpriseRelationId == 0) {
					data1.push(list.stockCode);
				}
			});
			let batchCode = data1.join(',');
			if (data1.length < 1) {
				return;
			};
			var ajaxurl = this.$api.cyl.enterpriseRelation.addEnterprise(), ajaxdata = { stockCode: batchCode, type: 1 };
			$.ajax({
				type: "POST",
				url: ajaxurl,
				data: ajaxdata,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					var msgtext = '';
					console.log('已批量加入我熟悉的企业', res)
					if (res.success) {
						msgtext = '已批量加入我熟悉的企业';
						_this.getThirdRelationList(_this.page);
					} else {
						msgtext = res.msg;
					}
					_this.$message({
						type: res.success ? 'success' : 'error',
						message: msgtext,
					});
				}
			})
		},
		getcacheRelatedlist(cluetype) {
			this.getEnterpriseRelated(1).then(res => { //需要等一级关系执行完成后再执行二级关系
				console.log(res);
				this.getLevel2List('cache');

			})
		},
		//获取企业触达线索 二级线索 type=calcu 新计算 type=cache初始拿缓存
		getLevel2List(type, enterpriseName, stockcode) {
			this.bus.$emit('loading', true);
			var _this = this;
			var usercityn = this.splicing('userCity', this.calcuCityid);/* 本地只有vip001才有数据 */
			var ajaxurl = this.$api.cyl.collect.enterpriseRelatedLevel2();
			var namelist = [], nametext = "";
			for (var i = 0; i < this.secondaryNameList.length; i++) {
				namelist.push(this.secondaryNameList[i].stockCode)
			}
			if (type == 'cache') {
				nametext = namelist.join(',');
				ajaxurl = ajaxurl + '?cache=' + nametext + usercityn;

			} else {
				ajaxurl = ajaxurl + '?stockCode=' + stockcode + usercityn;
			}

			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('获取二级企业作战线索', ajaxurl, res.data);
				let reslist = res.data.list ? res.data.list : [];
				if (reslist.length > 0) {
					_this.handleRelatedList(reslist, 2);
					_this.secondaryEmptyText = "计算结果";
				} else {
					if (type == 'cache') {
						_this.secondaryList = [];
					} else if (type == 'calcu') {
						var list = { title: enterpriseName, stockCode: stockcode, children: [] };
						_this.secondaryList.push(list);
					}
				}
				_this.bus.$emit('loading', false);

			})
		},
		//获取企业作战一级线索
		getEnterpriseRelated(level, pages) {
			return new Promise((resolve, reject) => {
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var _this = this;
				var usercityn = this.splicing('userCity', this.calcuCityid);/* 本地只有vip001才有数据 */
				this.$axios.get(this.$api.cyl.collect.enterpriseRelated() + '?page=' + this.page + '&level=' + level + usercityn, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function (res) {
					console.log('获取企业作战线索', _this.$api.cyl.collect.enterpriseRelated() + '?page=' + _this.page + '&level=' + level + usercityn, res.data);
					let reslist = res.data.list ? res.data.list : [];
					_this.handleRelatedList(reslist, level);
					resolve('请求一级作战线索成功');
					_this.bus.$emit('loading', false);
				})
			})
		},

		//处理企业触达线索数据 
		handleRelatedList(datalist, level) {
			if (level == 1) {
				// console.log(datalist) 
				this.secondaryNameList = datalist.filter(list => {
					return list.num == 0;
				})
				if (this.secondaryNameList.length == 0) {
					this.secondaryEmptyText = "暂无二级关系企业列表";
				}
				datalist = datalist.filter(list => {
					return list.num > 0;
				})
				datalist = this.getDataName(datalist);
				var oneNameList = "";
				for (var i = 0; i < datalist.length; i++) {
					oneNameList = oneNameList += '&' + datalist[i].title;
				}
				let exdata = [];
				for (var i = 0; i < datalist.length; i++) {
					// if (!datalist[i].isempty) {

					let smlist = {
						title: datalist[i].title,
						stockCode: datalist[i].stockCode,
						grade: 1,
						rowspan: 1,
						relationship: 'a',
						smtitle: "",
						smstockCode: 0,
						phone: "a",
						address: "a",
						isCounty: 0,
					};
					let rowspannum = 0;
					for (var d = 0; d < datalist[i].children.length; d++) {
						let culist = datalist[i].children[d].list;
						smlist.relationship = datalist[i].children[d].relationship;
						for (var s = 0; s < culist.length; s++) {
							var isfirst = d == 0 && s == 0;
							if (!isfirst) {
								smlist.grade = 2;
							}
							// console.log(d,s,d == 0 && s == 0,smlist.grade)
							rowspannum++;
							// console.log('culist-----',culist[s].middleList);

							smlist.smtitle = culist[s].title;
							smlist.smstockCode = culist[s].stockCode;
							smlist.phone = culist[s].phone;
							smlist.address = culist[s].address;
							smlist.rowspan = rowspannum;
							smlist.grade = isfirst ? 1 : 2;
							smlist.isCounty = culist[s].isCounty;
							let ddd = smlist;
							// console.log('smdata-----',smlist)
							exdata.push({
								title: datalist[i].title,
								stockCode: datalist[i].stockCode,
								grade: isfirst ? 1 : 2,
								rowspan: datalist[i].rowspanum,
								relationship: datalist[i].children[d].relationship,
								smtitle: culist[s].title,
								smstockCode: culist[s].stockCode,
								phone: culist[s].phone,
								address: culist[s].address,
								isCounty: culist[s].isCounty,
								middleList: culist[s].middleList,//机构、协会、商会之才有数据其他为 []
							})
						}
					}
					// }
				}
				this.oneNameList = oneNameList;
				this.RelatedList = exdata;
				this.firstCompanyNum = this.userdata.isFree ? 1 : exdata.length;
			} else if (level == 2) {
				// let onelist = this.oneNameList;  
				// datalist = datalist.filter(list => {
				// 	return onelist.indexOf(list.title) < 0 && list.num>0;
				// })
				console.log('二级计算', datalist, '-----', this.secondaryNameList);
				for (var d = 0; d < this.secondaryNameList.length; d++) {
					for (var i = 0; i < datalist.length; i++) {
						// console.log(this.secondaryNameList[d].stockCode,datalist[i].stockCode);
						if (this.secondaryNameList[d].stockCode == datalist[i].stockCode) {
							console.log(this.secondaryNameList[d].title);
							this.secondaryNameList[d].iscache = true;
						}
					}
				}

				datalist = this.getDataName(datalist);
				console.log('二级计算---', datalist, '-----', this.secondaryNameList);
				for (var i = 0; i < datalist.length; i++) {
					let smdata = datalist[i].children;
					for (var d = 0; d < smdata.length; d++) {
						let smmdata = smdata[d].list;
						smdata[d].list = this.getDataNameL2(smmdata, 'l2');
					}
				}

				// console.log('二级线索1遍历', datalist);
				this.secondaryList = this.secondaryList.concat(datalist);
				this.secondCompanyNum = this.userdata.isFree ? 1 : this.secondaryList.length;
				console.log('二级线索列表遍历', this.secondaryList)
			}
			this.bus.$emit('loading', false);
		},
		getDataNameL2(datalist) {
			//第二级和第一级格式不同
			for (var i = 0; i < datalist.length; i++) {
				datalist[i].children = [];
				var onelevelData = datalist[i].data, rowspanum = 0;
				datalist[i].children = [];
				if (onelevelData.controlEnterprise) {
					for (var d = 0; d < onelevelData.controlEnterprise.length; d++) {
						let smdata = onelevelData.controlEnterprise[d];
						smdata.relationship = "控制企业";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
				}
				if (onelevelData.customer) {
					for (var d = 0; d < onelevelData.customer.length; d++) {
						let smdata = onelevelData.customer[d];
						smdata.relationship = "客户";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
				}
				if (onelevelData.invest) {
					for (var d = 0; d < onelevelData.invest.length; d++) {
						let smdata = onelevelData.invest[d];
						smdata.relationship = "对外投资";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
				}
				if (onelevelData.shareholder) {
					for (var d = 0; d < onelevelData.shareholder.length; d++) {
						let smdata = onelevelData.shareholder[d];
						smdata.relationship = "股东";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
				}
				if (onelevelData.supplier) {
					for (var d = 0; d < onelevelData.supplier.length; d++) {
						let smdata = onelevelData.supplier[d];
						smdata.relationship = "供应商";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					datalist[i].rowspanum = rowspanum;
				}
				if (onelevelData.org) {
					for (var d = 0; d < onelevelData.org.length; d++) {
						let smdata = onelevelData.org[d];
						smdata.relationship = "投资机构";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					datalist[i].rowspanum = rowspanum;
				}
				if (onelevelData.commerce) {
					for (var d = 0; d < onelevelData.commerce.length; d++) {
						let smdata = onelevelData.commerce[d];
						smdata.relationship = "商会";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					datalist[i].rowspanum = rowspanum;
				}
				if (onelevelData.association) {
					for (var d = 0; d < onelevelData.association.length; d++) {
						let smdata = onelevelData.association[d];
						smdata.relationship = "协会";
						datalist[i].children.push(smdata);
						rowspanum++;
					}
					datalist[i].rowspanum = rowspanum;
				}
			}
			return datalist;



		},
		getDataName(datalist) {
			for (var i = 0; i < datalist.length; i++) {
				var defautData = { controlEnterprise: [], customer: [], invest: [], shareholder: [], supplier: [] };
				var onelevelData = datalist[i].data ? datalist[i].data : defautData, rowspanum = 0;
				datalist[i].children = [];
				if (onelevelData.controlEnterprise && onelevelData.controlEnterprise.length > 0) {
					datalist[i].children.push({
						relationship: "控制企业",
						list: onelevelData.controlEnterprise
					});
					rowspanum += onelevelData.controlEnterprise.length;
				}
				if (onelevelData.customer && onelevelData.customer.length > 0) {
					datalist[i].children.push({
						relationship: "客户",
						list: onelevelData.customer
					})
					rowspanum += onelevelData.customer.length;
				}
				if (onelevelData.invest && onelevelData.invest.length > 0) {
					datalist[i].children.push({
						relationship: "对外投资",
						list: onelevelData.invest
					})
					rowspanum += onelevelData.invest.length;
				}
				if (onelevelData.shareholder && onelevelData.shareholder.length > 0) {
					datalist[i].children.push({
						relationship: "股东",
						list: onelevelData.shareholder
					})
					rowspanum += onelevelData.shareholder.length;
				}
				if (onelevelData.supplier && onelevelData.supplier.length > 0) {
					datalist[i].children.push({
						relationship: "供应商",
						list: onelevelData.supplier,
					})
					rowspanum += onelevelData.supplier.length;
				}
				if (onelevelData.org && onelevelData.org.length > 0) {
					datalist[i].children.push({
						relationship: "投资机构",
						list: onelevelData.org,
					})
					rowspanum += onelevelData.org.length;
				}
				if (onelevelData.commerce && onelevelData.commerce.length > 0) {
					datalist[i].children.push({
						relationship: "商会",
						list: onelevelData.commerce,
					})
					rowspanum += onelevelData.commerce.length;
				}
				if (onelevelData.association && onelevelData.association.length > 0) {
					datalist[i].children.push({
						relationship: "协会",
						list: onelevelData.association,
					})
					rowspanum += onelevelData.association.length;
				}
				datalist[i].rowspanum = rowspanum;
			}
			return datalist;
		},


	},
}
</script>

<style scoped lang="scss">
.display-block {
	display: block;
}

.user_tabtitle1 {
	height: 38px;
	line-height: 38px;
	margin-bottom: 32px;
}

.user_tabtitle1 li {
	width: calc(33% - 4px);
	text-align: center;
	cursor: pointer;
	font-size: 16px;
	text-align: center;
	border: 1px solid #5E83CC;

	&.current,
	&:hover {
		background: #5E83CC;
		color: #fff;
	}
}

.secondarylist li {
	width: 29%;
	height: 32px;
	line-height: 32px;
	margin-bottom: 20px;
	float: left;
	margin-right: 2%;
	margin-left: 1%;
}

.caculatBtn {
	background: #f8f8f8;
	color: #999;
	width: 80px;
	text-align: center;
	border-radius: 6px;
	font-size: 15px;

	&.basebtn {
		background: #5E83CC;
		color: #fff;
		cursor: pointer;
	}
}

.secondaryEmptyText {
	text-align: center;
	height: 42px;
	line-height: 42px;
	background: #d4e0f8;
	margin-bottom: 30px;
	margin-top: 30px;
}

.collectfont2 span {
	cursor: pointer;
	color: #5E83CC;
	margin: 0 10px;
	font-size: 15px;
}

.opport-screen dt.long-font {
	width: 100px;
	margin-right: 20px;
	background-size: 100% 100%;
}

.nopadding {
	td {
		padding: 0 !important;
	}

	.curp-a,
	.curp {
		line-height: 40px;
	}
}
</style>
